// extracted by mini-css-extract-plugin
export default {"BreadCrumb":"Breadcrumb_BreadCrumb__4IkW5","item":"Breadcrumb_item__XxNhr","active":"Breadcrumb_active__czN38"};